import { render, staticRenderFns } from "./_imageTextLeft.vue?vue&type=template&id=bfe71ec2&"
import script from "./_imageTextLeft.vue?vue&type=script&lang=js&"
export * from "./_imageTextLeft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports